// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoader_container__BmIXk","spinner":"PageLoader_spinner__9f2_F"};